import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    // Prevent reinitialization or don't initialize if we're not in an iframe
    if (window.self === window.top) {
      return
    }

    this.insertExperienceHTML()
  }

  insertExperienceHTML () {
    const base = window.xprops.url.includes('http') ? undefined : new URL(document.location).origin
    const url = new URL(window.xprops.url, base)
    url.searchParams.append('layout', 'false')
    console.log('insertExperienceHTML fetching URL:', url.href)
    fetch(url.href)
      .then(res => res.text())
      .then(data => {
        if (data.startsWith('<article class="JourneyModal"')) {
          document.body.style.height = '100%'
          document.body.firstElementChild.style.height = '100%'
        }

        this.element.innerHTML = data

        this.scrollTo(url.hash)
      })
  }

  /**
   * Scroll smoothly to a specific section of the page, e.g. an ingredient in an experience.
   * @param {string} anchor - An anchor ID to scroll to, including the '#'. Example: #ingredient-cotton
   */
  scrollTo (anchor) {
    if (!anchor) return
    const el = document.querySelector(anchor)
    if (el) {
      const offset = el.getBoundingClientRect().top
      const header = document.querySelector('.ExperienceStickyHeader')
      const headerOffset = (header && header.clientHeight) || 72
      const top = offset - headerOffset
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
